import type { NotFoundUiContent } from '../../not-found-ui-content';

export const notFound: NotFoundUiContent = {
  eyebrow: 'పేజీ కనుగొనబడలేదు',
  title: 'ఆ పేజీని మేము కనుగొనలేకపోయాము',
  body: 'లింక్ పాతది కావచ్చు, లేదా పేజీ తీసివేయబడి ఉండవచ్చు. మీరు దేని కోసం చూస్తున్నారో చెప్పండి, మేము దాన్ని కనుగొంటాము.',
  suggestionsTitle: 'మీరు వెతుకుతున్నది ఇవి కావచ్చు',
  bestMatchTitle: 'మీ ఉద్దేశం ఇదేనా',
  prefillHint: 'మీరు ప్రయత్నించిన చిరునామా ఆధారంగా ముందే నింపబడింది',
  goHome: 'హోమ్',
  browseAll: 'అన్ని వర్గాలు',
  reportBrokenLink: 'పనిచేయని లింక్‌ను నివేదించండి',
  noticeTitle: 'ఆ పేజీ అందుబాటులో లేదు',
  noticeSearching: 'బదులుగా {query} కోసం శోధిస్తున్నాము…',
  noticePrefilled: 'క్రింద {query} కోసం శోధించండి, లేదా మీరు దేని కోసం చూస్తున్నారో మాకు చెప్పండి.',
  errorTitle: 'ఏదో పొరపాటు జరిగింది',
  errorBody: 'ఈ పేజీని లోడ్ చేయలేకపోయాము. మళ్లీ ప్రయత్నించండి, లేదా మీకు కావలసినదాని కోసం క్రింద శోధించండి.',
  retry: 'మళ్లీ ప్రయత్నించండి',
  streamLostTitle: 'ఈ పేజీని మేము పూర్తి చేయలేకపోయాము',
  streamLostBody: 'పేజీ సేవ్ అయ్యే ముందే శోధన ఆగిపోయింది. దాన్ని మళ్లీ ప్రారంభించండి, మీ మాటల నుండే మేము కొనసాగిస్తాము.',
  relaunch: 'మళ్లీ శోధించండి',
};
